import { Zap, PenLine, Sparkles, LayoutList } from 'lucide-react';

const THINKING_MODES = [
  { id: 'general', label: 'General', icon: Zap, description: 'All-purpose assistant', color: 'text-blue-400' },
  { id: 'emails', label: 'Emails', icon: PenLine, description: 'Draft and reply', color: 'text-amber-400' },
  { id: 'ideas', label: 'Ideas', icon: Sparkles, description: 'Brainstorm and create', color: 'text-violet-400' },
  { id: 'projects', label: 'Projects', icon: LayoutList, description: 'Plan and organize', color: 'text-emerald-400' }
];

const QUICK_PROMPTS = [
  { text: "Draft an email to...", mode: "emails", prompt: "Help me draft an email to " },
  { text: "I have an idea about...", mode: "ideas", prompt: "I have an idea I want to explore: " },
  { text: "Plan a project for...", mode: "projects", prompt: "Help me plan a project for " },
  { text: "Reply to this email...", mode: "emails", prompt: "Help me reply to this email: " }
];

const EmptyState = ({ mode, setMode, setInput, textareaRef }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="relative inline-block mb-4">
        <div className="absolute -top-1.5 left-1">
          <div
            className="bg-white text-background px-1.5 py-0.5 rounded text-[10px] font-bold leading-none"
            style={{ fontFamily: "'Coco Gothic', sans-serif" }}
          >
            hey
          </div>
          <div className="absolute -bottom-0.5 left-2 w-1.5 h-1.5 bg-white transform rotate-45"></div>
        </div>
        <span
          className="text-5xl font-bold tracking-tight"
          style={{ fontFamily: "'Coco Gothic', sans-serif" }}
        >
          arlo
        </span>
      </div>
      <p className="text-muted-foreground max-w-md mb-8">
        Your personal assistant for emails, ideas, and projects
      </p>

      <div className="w-full max-w-md space-y-2 mb-8">
        {QUICK_PROMPTS.map((qp, idx) => (
          <button
            key={idx}
            onClick={() => {
              setMode(qp.mode);
              setInput(qp.prompt);
              textareaRef?.current?.focus();
            }}
            className="w-full text-left px-4 py-3 rounded-lg border border-border hover:border-muted-foreground/50 hover:bg-muted/50 transition-all group"
            data-testid={`quick-prompt-${idx}`}
          >
            <span className="text-muted-foreground group-hover:text-foreground transition-colors">
              {qp.text}
            </span>
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
        <span>or select a mode:</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 w-full max-w-lg">
        {THINKING_MODES.map((m) => {
          const Icon = m.icon;
          return (
            <button
              key={m.id}
              onClick={() => setMode(m.id)}
              className={`p-3 rounded-lg border transition-all ${
                mode === m.id
                  ? 'border-accent bg-accent/10'
                  : 'border-border hover:border-muted-foreground/50 hover:bg-muted/50'
              }`}
              data-testid={`empty-mode-${m.id}`}
            >
              <Icon
                className={`h-5 w-5 mx-auto mb-1 ${
                  mode === m.id ? m.color : 'text-muted-foreground'
                }`}
              />
              <div
                className={`text-xs font-medium ${
                  mode === m.id ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {m.label}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EmptyState;
